import React, { useId, useState } from "react";

function PasswordVisibilityIcon({ visible }) {
  return (
    <span style={styles.iconFrame} aria-hidden="true">
      <span style={styles.eyeShape}>
        <span style={styles.eyePupil} />
      </span>
      {visible ? <span style={styles.eyeSlash} /> : null}
    </span>
  );
}

function PasswordField({
  label,
  value,
  onChange,
  placeholder,
  disabled = false,
  autoComplete,
  name,
}) {
  const inputId = useId();
  const [visible, setVisible] = useState(false);
  const toggleLabel = visible ? "Ocultar contrasena" : "Mostrar contrasena";

  return (
    <div style={styles.field}>
      <label htmlFor={inputId} style={styles.label}>
        {label}
      </label>
      <span style={styles.inputWrap}>
        <input
          id={inputId}
          type={visible ? "text" : "password"}
          name={name}
          value={value}
          onChange={onChange}
          style={styles.input}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete={autoComplete}
        />
        <button
          type="button"
          style={styles.toggleButton}
          onClick={() => setVisible((current) => !current)}
          disabled={disabled}
          aria-label={toggleLabel}
          title={toggleLabel}
        >
          <PasswordVisibilityIcon visible={visible} />
        </button>
      </span>
    </div>
  );
}

const styles = {
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    color: "#1e293b",
    fontWeight: 600,
  },
  inputWrap: {
    position: "relative",
    display: "block",
  },
  input: {
    width: "100%",
    borderRadius: "12px",
    border: "1px solid #dbe2ea",
    padding: "12px 50px 12px 14px",
    fontSize: "15px",
    boxSizing: "border-box",
  },
  toggleButton: {
    position: "absolute",
    top: "50%",
    right: "4px",
    width: "40px",
    height: "40px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transform: "translateY(-50%)",
    border: "none",
    borderRadius: "8px",
    backgroundColor: "transparent",
    color: "#475569",
    cursor: "pointer",
  },
  iconFrame: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "22px",
    height: "18px",
  },
  eyeShape: {
    position: "relative",
    display: "block",
    width: "16px",
    height: "16px",
    border: "2px solid currentColor",
    borderRadius: "75% 15%",
    transform: "rotate(45deg)",
    boxSizing: "border-box",
  },
  eyePupil: {
    position: "absolute",
    top: "4px",
    left: "4px",
    width: "4px",
    height: "4px",
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  eyeSlash: {
    position: "absolute",
    width: "23px",
    height: "2px",
    borderRadius: "999px",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)",
    boxShadow: "0 0 0 2px #ffffff",
  },
};

export default PasswordField;
